// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Reviews__materialize-textarea___29Bvi","modal-2463794813":"Reviews__modal-2463794813___UgawX","container":"Reviews__container___1kanP","reviewsContainer":"Reviews__reviewsContainer___3AJP9","reviewHeader":"Reviews__reviewHeader___2Suil","review":"Reviews__review___1JWoB","reviewBy":"Reviews__reviewBy___22ED1","textContainer":"Reviews__textContainer___1-NIS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reviews/Reviews.scss
// module id = 1525
// module chunks = 0